const environment = process.env.REACT_APP_ENVIRONMENT;
let propertySvcAwsConfigV0 = {};
let propertySvcAwsConfigV1 = {};
let propertySvcAwsConfigV2 = {};
let propertySvcAwsConfigV3 = {};
let propertySvcAwsConfigV4 = {};
let propertySvcAwsConfigV5 = {};
let propertySvcAwsConfigV6 = {};
let propertySvcAwsConfigV7 = {};
let integrationSvcAwsConfigV0 = {};
let integrationSvcAwsConfigV1 = {};
let integrationSvcAwsConfigV2 = {};
let integrationSvcAwsConfigV3 = {};
let integrationSvcAwsConfigV4 = {};
let integrationSvcAwsConfigV5 = {};
let integrationSvcAwsConfigV10 = {};
let propertySpecificUrl = '';
let ssoClientId = '';
let ssoTokenUrl = '';
let x_api_key = '';
let ddlGraphqlEndpoint = '';
let ddlApiKey = '';
let ddlDeactivateEndpoint = '';
let ddlDeactivateApiKey = '';

switch (environment) {
  case 'dev':
    ssoClientId = '5e6dv3pu0go5f5fp5hp41sg3ed';
    ssoTokenUrl = 'https://hudini-saml-dev.auth.ap-south-1.amazoncognito.com/oauth2/token';
    propertySpecificUrl = 'https://nxzyicu8qf.execute-api.ap-south-1.amazonaws.com/dev';
    x_api_key = '676FVHHflZ1wn1ELnlbFW3tRpbmzddOI5EiJbfjU';
    propertySvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v0.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v1.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v2.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://l5ycqjg5ybemfhkk52odx7hxqm.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://5p7vgu36dvbyveqlrfx2p5zy7y.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://wnaqgkwjqzh4bfwatrruzguffu.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV6 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://zjmuqawoq5azfcndh7jjlrmroa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV7 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://gewynin7bzcj5ibk2rkvk3zboq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v0.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v1.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://kuwnmrmpt5harj2lmzzjflol5a.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://tkcbfa7xffhwrcsrhqfzha4jwy.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://omh3m6cx2ja5tfwngpuymz6uxm.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://is77e7uqvba7fdt46qfzys7qie.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV10 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://k6ard5y7vrce3byc57rpm53mlq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    ddlGraphqlEndpoint = 'https://gewynin7bzcj5ibk2rkvk3zboq.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlApiKey = 'da2-hvouvi6x4beflm57v4cy3qe5qa';
    ddlDeactivateEndpoint = 'https://tkcbfa7xffhwrcsrhqfzha4jwy.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlDeactivateApiKey = 'da2-feegsgasrjflppstet7xedmorm';
    break;
  case 'staging':
    ssoTokenUrl = 'https://hudini-saml-staging.auth.ap-south-1.amazoncognito.com/oauth2/token';
    ssoClientId = '7v8e2bef2r3898itvu28l9fuq';
    propertySpecificUrl = 'https://ba582eqxd2.execute-api.ap-south-1.amazonaws.com/staging';
    x_api_key = '7G0clMoS3698HplmSBCdnyDuxYyF9ro4MpWZJug3';
    propertySvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v0.hudinielevate-stage.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v1.hudinielevate-stage.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v2.hudinielevate-stage.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v3.hudinielevate-stage.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint:
        'https://3uw2rwq3dfap5hh2a2ixk4fu3i.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://vwhsgs7umjhpjm5f7qspm4qsdy.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV6 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://aevntsl5nbbktmjv6otsfn3dcu.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV7 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://rn6kznjopzgshgwcp7picsxzia.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v0.hudinielevate-stage.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v1.hudinielevate-stage.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint:
        'https://laz7s72p3bgorpfboh66zxkuaa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint:
        'https://4yf32isk7rbczobmu6cj4aksim.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint:
        'https://3qputreqgnarbl4acquterhckq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint:
        'https://wj7bdguo4rgu3krddax7symynu.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV10 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_jMPX2AzZm',
      userPoolWebClientId: '7v8e2bef2r3898itvu28l9fuq',
      aws_appsync_graphqlEndpoint:
        'https://dbbaobb5gfbvbjd3twuw47hypq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    ddlGraphqlEndpoint = 'https://rn6kznjopzgshgwcp7picsxzia.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlApiKey = 'da2-3ci2gv3dcre5xiad7eaorn3kum';
    ddlDeactivateEndpoint = 'https://4yf32isk7rbczobmu6cj4aksim.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlDeactivateApiKey = 'da2-pxnipshpkzexxj2sjqyafbea5m';
    break;
  case 'uat':
    ssoTokenUrl = 'https://hudinisingletenant-stage.auth.ap-south-1.amazoncognito.com/oauth2/token';
    ssoClientId = '7v8e2bef2r3898itvu28l9fuq';
    propertySpecificUrl = 'https://u5ci22cxa1.execute-api.ap-south-1.amazonaws.com/uat';
    x_api_key = 'DyyDb5hftr98wMG7Xirlf5bRB9VQwP6oaPcbb4Ij';
    propertySvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint: 'https://api-properties-a.hudini.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint: 'https://api-properties-b.hudini.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint: 'https://api-properties-c.hudini.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint: 'https://api-properties-d.hudini.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://sqlevztw2fdebcn352zori6y74.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://o5vy5fcibncbraqbbc4ev6kqlm.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV6 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://7nfl63er6va33avdary2rygpoi.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV7 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://ihmcaga2zzcjlghntaeyglqufa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-a.hudini.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-b.hudini.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://q7bg4aketzem7hvp2shbhxwi3i.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://tnntfeas5veote7c5rjiiy7yty.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://46ght4qkrrbqvdnuejg4tzeqga.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://xg2xfz3yvjafdm4pvvyfbeqwce.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV10 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://ezgdy6y6gndzxolq2jrozg6kjq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    ddlGraphqlEndpoint = 'https://ihmcaga2zzcjlghntaeyglqufa.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlApiKey = 'da2-d2pejgjhqbggbesq6rntq7mviu';
    ddlDeactivateEndpoint = 'https://api-integrations-d.hudini.io/graphql';
    ddlDeactivateApiKey = 'da2-pq3zavthcjgwxlkea6u6btba2m';
    break;

  case 'uat_us':
    ssoTokenUrl = 'https://hudinisingletenant-stage.auth.ap-south-1.amazoncognito.com/oauth2/token';
    ssoClientId = '7v8e2bef2r3898itvu28l9fuq';
    propertySvcAwsConfigV0 = {
      region: 'us-west-2',
      userPoolId: 'us-west-2_iyAWJmdAH',
      userPoolWebClientId: '1hfelp6elt3nbo0lf9pvt4821e',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v0-us.hudinielevate-uat.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'us-west-2',
    };
    propertySvcAwsConfigV1 = {
      region: 'us-west-2',
      userPoolId: 'us-west-2_iyAWJmdAH',
      userPoolWebClientId: '1hfelp6elt3nbo0lf9pvt4821e',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v1-us.hudinielevate-uat.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'us-west-2',
    };
    propertySvcAwsConfigV2 = {
      region: 'us-west-2',
      userPoolId: 'us-west-2_iyAWJmdAH',
      userPoolWebClientId: '1hfelp6elt3nbo0lf9pvt4821e',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v2-us.hudinielevate-uat.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'us-west-2',
    };
    propertySvcAwsConfigV3 = {
      region: 'us-west-2',
      userPoolId: 'us-west-2_iyAWJmdAH',
      userPoolWebClientId: '1hfelp6elt3nbo0lf9pvt4821e',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v3-us.hudinielevate-uat.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'us-west-2',
    };
    propertySvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://5p7vgu36dvbyveqlrfx2p5zy7y.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://5r52g55tq5cvncjvrb7z4pdu7u.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV6 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://q7bg4aketzem7hvp2shbhxwi3i.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV7 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://ihmcaga2zzcjlghntaeyglqufa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV0 = {
      region: 'us-west-2',
      userPoolId: 'us-west-2_iyAWJmdAH',
      userPoolWebClientId: '1hfelp6elt3nbo0lf9pvt4821e',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v0-us.hudinielevate-uat.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'us-west-2',
    };
    integrationSvcAwsConfigV1 = {
      region: 'us-west-2',
      userPoolId: 'us-west-2_iyAWJmdAH',
      userPoolWebClientId: '1hfelp6elt3nbo0lf9pvt4821e',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v1-us.hudinielevate-uat.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'us-west-2',
    };
    integrationSvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://tnntfeas5veote7c5rjiiy7yty.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://46ght4qkrrbqvdnuejg4tzeqga.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://xg2xfz3yvjafdm4pvvyfbeqwce.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV10 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_RNCPjN9xW',
      userPoolWebClientId: '4ft0noapmng6afs4kolvtde0rf',
      aws_appsync_graphqlEndpoint:
        'https://ezgdy6y6gndzxolq2jrozg6kjq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    ddlGraphqlEndpoint = 'https://ihmcaga2zzcjlghntaeyglqufa.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlApiKey = 'da2-d2pejgjhqbggbesq6rntq7mviu';
    ddlDeactivateEndpoint = 'https://api-integrations-d.hudini.io/graphql';
    ddlDeactivateApiKey = 'da2-pq3zavthcjgwxlkea6u6btba2m';
    break;

  case 'prod':
    ssoTokenUrl = 'https://hudinisingletenant-stage.auth.ap-south-1.amazoncognito.com/oauth2/token';
    ssoClientId = '7v8e2bef2r3898itvu28l9fuq';
    propertySpecificUrl = 'https://c3e7tgv3ve.execute-api.ap-south-1.amazonaws.com/prod';
    x_api_key = '4XPdL9BAqE81xgZ0dbpJC2jtDLqtVScxa8nF8NCS';
    propertySvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v0.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v1.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v2.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v3.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint:
        'https://tpq4hfkffjdyfnoqihdyx2moiu.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v1.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV6 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://o6ekqlztdjfypbp6n6eixj6cpi.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV7 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://ihmcaga2zzcjlghntaeyglqufa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v0.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v1.hudinielevate.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint:
        'https://dxr5jiq2svbeti2qo6yw7rwjae.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint:
        'https://q7bg4aketzem7hvp2shbhxwi3i.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint:
        'https://4smp4h24nzbb5jviwthcd62af4.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint:
        'https://ab6skeaitfasbb4jfcbnjgqixu.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV10 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_yCFE5JBel',
      userPoolWebClientId: '29as593lp6r05mr7mdf1di6emp',
      aws_appsync_graphqlEndpoint:
        'https://ezgdy6y6gndzxolq2jrozg6kjq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    ddlGraphqlEndpoint = 'https://wxuramqc2jdwpkcyr54zi2ddo4.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlApiKey = 'da2-7hcewnaxufc7jbcok4no6zdpxe';
    ddlDeactivateEndpoint = 'https://api-integrations-v3.hudinielevate.io/graphql';
    ddlDeactivateApiKey = 'da2-dr24oueb2jacdm7puh45ahdvra';
    break;
  default:
    ssoTokenUrl = 'https://hudinisingletenant-stage.auth.ap-south-1.amazoncognito.com/oauth2/token';
    ssoClientId = '7v8e2bef2r3898itvu28l9fuq';
    propertySpecificUrl = 'https://nxzyicu8qf.execute-api.ap-south-1.amazonaws.com/dev';
    propertySvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v0.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v1.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v2.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-properties-v3.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://5p7vgu36dvbyveqlrfx2p5zy7y.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://wnaqgkwjqzh4bfwatrruzguffu.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV6 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://zjmuqawoq5azfcndh7jjlrmroa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    propertySvcAwsConfigV7 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://gewynin7bzcj5ibk2rkvk3zboq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV0 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v0.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV1 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint: 'https://api-integrations-v1.hudinielevate-dev.io/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV2 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://kuwnmrmpt5harj2lmzzjflol5a.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV3 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://tkcbfa7xffhwrcsrhqfzha4jwy.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://omh3m6cx2ja5tfwngpuymz6uxm.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV4 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://omh3m6cx2ja5tfwngpuymz6uxm.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV5 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://is77e7uqvba7fdt46qfzys7qie.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    integrationSvcAwsConfigV10 = {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_bkjGOCKEa',
      userPoolWebClientId: '5e6dv3pu0go5f5fp5hp41sg3ed',
      aws_appsync_graphqlEndpoint:
        'https://k6ard5y7vrce3byc57rpm53mlq.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_region: 'ap-south-1',
    };
    ddlGraphqlEndpoint = 'https://gewynin7bzcj5ibk2rkvk3zboq.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlApiKey = 'da2-hvouvi6x4beflm57v4cy3qe5qa';
    ddlDeactivateEndpoint = 'https://tkcbfa7xffhwrcsrhqfzha4jwy.appsync-api.ap-south-1.amazonaws.com/graphql';
    ddlDeactivateApiKey = 'da2-feegsgasrjflppstet7xedmorm';
    break;
}

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const LOGGER_API_URL = process.env.REACT_APP_LOGGER_URL;
export const DEFAULT_HOTEL_ID = process.env.REACT_APP_DEFAULT_HOTEL_ID;
export const ASSET_URL = process.env.REACT_APP_ASSET_URL;
export const MESSAGEBIRD_ENDPOINT = process.env.REACT_APP_MESSAGEBIRD_ENDPOINT;
export const PROPERTY_SERVICE_V0_AWS_CONFIG = propertySvcAwsConfigV0;
export const PROPERTY_SERVICE_V1_AWS_CONFIG = propertySvcAwsConfigV1;
export const PROPERTY_SERVICE_V2_AWS_CONFIG = propertySvcAwsConfigV2;
export const PROPERTY_SERVICE_V3_AWS_CONFIG = propertySvcAwsConfigV3;
export const PROPERTY_SERVICE_V4_AWS_CONFIG = propertySvcAwsConfigV4;
export const PROPERTY_SERVICE_V5_AWS_CONFIG = propertySvcAwsConfigV5;
export const PROPERTY_SERVICE_V6_AWS_CONFIG = propertySvcAwsConfigV6;
export const PROPERTY_SERVICE_V7_AWS_CONFIG = propertySvcAwsConfigV7;
export const INTEGRATION_SERVICE_V0_AWS_CONFIG = integrationSvcAwsConfigV0;
export const INTEGRATION_SERVICE_V1_AWS_CONFIG = integrationSvcAwsConfigV1;
export const INTEGRATION_SERVICE_V2_AWS_CONFIG = integrationSvcAwsConfigV2;
export const INTEGRATION_SERVICE_V3_AWS_CONFIG = integrationSvcAwsConfigV3;
export const INTEGRATION_SERVICE_V4_AWS_CONFIG = integrationSvcAwsConfigV4;
export const INTEGRATION_SERVICE_V5_AWS_CONFIG = integrationSvcAwsConfigV5;
export const INTEGRATION_SERVICE_V10_AWS_CONFIG = integrationSvcAwsConfigV10;
export const DDL_GRAPHQL_ENDPOINT = ddlGraphqlEndpoint;
export const DDL_API_KEY = ddlApiKey;
export const DDL_DEACTIVATE_ENDPOINT = ddlDeactivateEndpoint;
export const DDL_DEACTIVATE_API_KEY = ddlDeactivateApiKey;
export const DOWNLOAD_ASSETS_URL = process.env.REACT_APP_DOWNLOAD_ASSETS_URL;
export const REACT_APP_FILE_UPLOAD_URL = process.env.REACT_APP_FILE_UPLOAD_URL;
export const PROPERTY_SERVICE_URL = propertySpecificUrl;
export const SSO_CLIENT_ID = ssoClientId;
export const SSO_TOKEN_URL = ssoTokenUrl;
export const X_API_KEY = x_api_key;
let _encryptionKey = null;

const encryption = {
  get ENCRYPTION_KEY() {
    return _encryptionKey;
  },
  set ENCRYPTION_KEY(value) {
    _encryptionKey = value;
  },
};

export default encryption;
